import { CoreInterfaces } from "./../../Models";
import * as Constants from "../../Constants/Constants";
import { applyUpdatesOnQuestionChange } from "src/utils/processors/Questions";

export function identityReducer(
  state: CoreInterfaces.AppState,
  action: { type: Constants.AppStateActions; payload?: any }
): Partial<CoreInterfaces.AppState> {
  switch (action.type) {
    case Constants.AppStateActions.UpdateAadUserInfo: {
      const authProviderUserDetails = action.payload
        .authProviderUserDetails as CoreInterfaces.AuthProviderUserDetails;
      const nextState = {
        ...state,
        authProviderUserDetails,
      };
      return nextState;
    }
    case Constants.AppStateActions.UpdateApplicationLanguage: {
      const language = action.payload.language as Constants.Languages;
      const nextState = {
        ...state,
        language,
      };

      applyUpdatesOnQuestionChange(
        nextState,
        state.services.find(
          (eachService) =>
            eachService.data.code ===
              Constants.ServiceCode
                .PayrollAndExpenseAndTravelInvoiceManagement ||
            eachService.data.code === Constants.ServiceCode.GeneralInformation
        )
      );

      return nextState;
    }
    default:
      return {};
  }
}
